import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "organizationSelect", "userTypeSelect", "template"]

  connect() {
    // Use timestamp-based index to avoid conflicts with existing records
    // Rails fields_for uses sequential indices (0, 1, 2, etc.)
    // We use large numbers (timestamp) for new records to avoid collisions
    this.nextIndex = new Date().getTime()
  }

  addOrganization(event) {
    event.preventDefault()
    console.log("Add organization clicked")

    const organizationSelect = this.organizationSelectTarget
    const userTypeSelect = this.userTypeSelectTarget
    const organizationId = organizationSelect.value
    let organizationName = organizationSelect.options[organizationSelect.selectedIndex].text
    const userType = userTypeSelect.value
    const userTypeLabel = userTypeSelect.options[userTypeSelect.selectedIndex].text

    console.log("Selected org ID:", organizationId, "User type:", userType)

    if (!organizationId) {
      alert("Please select an organization")
      return
    }

    if (this.isDuplicateOrganization(organizationId)) {
      alert("This organization has already been added")
      return
    }

    // Remove tree indentation markers (e.g., "-- Artist Name" becomes "Artist Name")
    organizationName = organizationName.replace(/^--\s*/, "")

    const row = this.createOrganizationRow(organizationId, organizationName, userType, userTypeLabel)
    console.log("Created row:", row)
    console.log("Appending to container:", this.containerTarget)
    this.containerTarget.appendChild(row)
    console.log("Row appended, container now has", this.containerTarget.children.length, "children")

    organizationSelect.selectedIndex = 0
    userTypeSelect.selectedIndex = 0

    this.nextIndex++
  }

  removeOrganization(event) {
    event.preventDefault()

    if (!confirm("Are you sure you want to remove this organization from the user?")) {
      return
    }

    const row = event.currentTarget.closest(".organization-row")

    const destroyField = row.querySelector('input[name*="_destroy"]')
    if (destroyField) {
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }

  isDuplicateOrganization(organizationId) {
    const rows = this.containerTarget.querySelectorAll(".organization-row")
    for (const row of rows) {
      if (row.style.display === "none") continue

      const orgIdInput = row.querySelector('input[name*="[organization_id]"]')
      if (orgIdInput && orgIdInput.value === organizationId) {
        return true
      }
    }
    return false
  }

  createOrganizationRow(organizationId, organizationName, userType, userTypeLabel) {
    const row = document.createElement("div")
    row.className = "organization-row flex items-center justify-between p-3 bg-gray-50 rounded-md border border-gray-300"

    const index = this.nextIndex

    row.innerHTML = `
      <div class="flex-1">
        <div class="text-sm font-medium text-gray-900">${organizationName}</div>
        <div class="text-xs text-gray-500">${userTypeLabel}</div>
      </div>
      <button type="button"
              class="text-red-600 hover:text-red-900 cursor-pointer"
              data-action="click->user-organization#removeOrganization">
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>
      <input type="hidden"
             name="user[user_organizations_attributes][${index}][organization_id]"
             value="${organizationId}">
      <input type="hidden"
             name="user[user_organizations_attributes][${index}][user_type]"
             value="${userType}">
    `

    return row
  }

  createExistingOrganizationRow(userOrgId, organizationId, organizationName, userType, userTypeLabel) {
    const row = document.createElement("div")
    row.className = "organization-row flex items-center justify-between p-3 bg-gray-50 rounded-md border border-gray-300"

    const index = this.nextIndex

    row.innerHTML = `
      <div class="flex-1">
        <div class="text-sm font-medium text-gray-900">${organizationName}</div>
        <div class="text-xs text-gray-500">${userTypeLabel}</div>
      </div>
      <button type="button"
              class="text-red-600 hover:text-red-900 cursor-pointer"
              data-action="click->user-organization#removeOrganization">
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>
      <input type="hidden"
             name="user[user_organizations_attributes][${index}][id]"
             value="${userOrgId}">
      <input type="hidden"
             name="user[user_organizations_attributes][${index}][organization_id]"
             value="${organizationId}">
      <input type="hidden"
             name="user[user_organizations_attributes][${index}][user_type]"
             value="${userType}">
      <input type="hidden"
             name="user[user_organizations_attributes][${index}][_destroy]"
             value="0">
    `

    return row
  }
}
